import React from 'react';
import { useSelector } from 'react-redux';
import { useAccountContext } from '../../context/useAccountContext';
import { TabSlugOptions, WorkflowTabSlugOptions } from '../../types/tab';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { hasAccessToLinkAccountsSelector } from '../../../../CommonSelectors/CommonAreaSelector';
import { SimpleTab } from '../../../../CommonComponents/OPL/Tab/SimpleTab';

export const TabMenu = () => {
  const { clientId, tabSlug, isWorkflow } = useAccountContext();
  const hasAccessToLinkAccounts = useSelector(hasAccessToLinkAccountsSelector);

  return (
    <Box display="flex">
      <SimpleTab
        isActive={tabSlug === TabSlugOptions.preferences}
        onClick={() => {
          if (isWorkflow) {
            const { params } = ADV.util.Router.getObjFromHash(ADV.util.getHash());
            ADV.util.Router.go2('Workflow', {
              ...params,
              clientId,
              pageId: WorkflowTabSlugOptions.accounts,
            });
          } else if (tabSlug !== TabSlugOptions.preferences) {
            // Only redirect to Profile Accounts when we are not there
            // If we do, we re-initialize redux and some data is missing.
            ADV.util.Router.go2('ProfileAccounts', {
              clientId,
              tabSlug: TabSlugOptions.preferences,
            });
          }
        }}
      >
        Account Preferences
      </SimpleTab>

      {hasAccessToLinkAccounts && (
        <SimpleTab
          isActive={tabSlug === TabSlugOptions.manageLinks}
          onClick={() => {
            if (isWorkflow) {
              const { params } = ADV.util.Router.getObjFromHash(ADV.util.getHash());
              ADV.util.Router.go2('Workflow', {
                ...params,
                clientId,
                pageId: WorkflowTabSlugOptions.manageLinks,
                institutionId: '',
              });
            } else if (tabSlug !== TabSlugOptions.manageLinks) {
              // Only redirect to Profile Accounts when we are not there
              // If we do, we re-initialize redux and some data is missing.
              ADV.util.Router.go2('ProfileAccounts', {
                clientId,
                tabSlug: TabSlugOptions.manageLinks,
                entityId: '',
              });
            }
          }}
          ml="8"
        >
          Link Management
        </SimpleTab>
      )}
    </Box>
  );
};
